import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import { PAGE_NAMES, MISCELLANEOUS_RESOURCES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import MiscellaneousHome from './MiscellaneousHome';
import { URL, COMPONENT } from './helper';

const Dashboard: React.FC<{}> = () => {
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<Switch>
				<AuthorizedRouteV2
					exact
					configPageName={PAGE_NAMES.miscellaneous}
					path={`/${PAGE_NAMES.miscellaneous}`}
					component={MiscellaneousHome}
				/>
				{_map(_values(MISCELLANEOUS_RESOURCES), (resourceName: string) => (
					<AuthorizedRouteV2
						key={resourceName}
						configPageName={PAGE_NAMES.miscellaneous}
						configResourceName={resourceName}
						path={URL[resourceName]}
						component={COMPONENT[resourceName]}
					/>
				))}
				<Redirect to={`/${PAGE_NAMES.miscellaneous}`} />
			</Switch>
		</>
	);
};

export default Dashboard;
